import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import styles from './WizardFamilyMemberCard.module.scss';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.FAMILY_MEMBER_CARD }>;
}

const WizardFamilyMemberCard: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			<div>
				<img
					src={item.settings.profileImageUrl}
					alt={item.settings.fullName}
					className={styles.image}
				/>
			</div>
			<div className={styles.content}>
				<div className={styles.title}>{item.settings.fullName}</div>
				<div>{item.settings.typeFormatted}</div>
			</div>
		</div>
	);
};

export default WizardFamilyMemberCard;
